/**
 * How long a single photo is shown for
 */
export const defaultPhotoDurationMs = 2_000;
